import { gql } from "@apollo/client";
import Form from "components/common/form/Form";
import DateInput from "components/common/form/inputs/date/DateInput";
import Input from "components/common/form/inputs/Input";
import Textarea from "components/common/form/inputs/Textarea";
import FormActions from "components/common/form/partials/FormActions";
import { graph } from "config/axios-context";
import { useState } from "react";
import { WalletTransactionInput } from "types/graphql";
import useAppContext from "utilities/hooks/useAppContext";

export type WalletTransactionFromProps = {
    walletId: number;
    model?: WalletTransactionModel;
    onSave: () => void;
};

type WalletTransactionModel = {
    id?: number | null | string | undefined;
    walletId: number;
    amount: number | string | undefined | null;
    note?: string | null;
    transactionDate: Date | undefined;
    transactionId?: string | null;
}

const mutation = gql`
mutation SaveWalletTransaction($model: WalletTransactionInput!) {
  walletTransaction(model: $model) {
    id
  }
}
`;

const WalletTransactionFrom = (props: WalletTransactionFromProps) => {
    const constext = useAppContext();
    const [model, setModel] = useState<WalletTransactionModel>({
        ...props.model,
        walletId: props.walletId,
        transactionDate: props.model?.transactionDate ? new Date(props.model?.transactionDate) : new Date(),
        amount: props.model?.amount || ''
    });
    const [disableInputs, setDisableInputs] = useState(false);

    const onSubmit = async () => {
        setDisableInputs(true);
        try {
            const requestModel: WalletTransactionInput = {
                amount: Number(model.amount),
                note: model.note,
                transactionDate: model.transactionDate,
                transactionId: model.transactionId,
                walletId: model.walletId,
                id: model.id ? Number(model.id) : 0
            }

            var response = await graph({
                query: mutation,
                variables: {
                    model: requestModel
                }
            });

            if (!response.success) {
                throw response.data;
            }

            props.onSave();
        } catch (e) {
            console.error(e);
        } finally {
            setDisableInputs(false);
        }
    }

    return (
        <div>
            <Form name={"walletI-transaction-form-" + props.walletId} onSubmit={onSubmit}>
                <fieldset>
                    <DateInput
                        label={constext.t('fields.date.name')}
                        value={model.transactionDate}
                        required
                        onChange={v => setModel({...model, transactionDate: v})}
                    />
                    <Input 
                        label={constext.t('fields.amount.name')}
                        type="number"
                        required
                        value={model.amount?.toString() || ''}
                        onChange={v => setModel({...model, amount: v})}
                    />
                    <Input
                        label={constext.t('fields.amount.transaction-id')}
                        value={model.transactionId?.toString() || ''}
                        onChange={v => setModel({ ...model, transactionId: v })}
                    />
                    <Textarea
                        label={constext.t('fields.note.name')}
                        value={model.note || ''}
                        onChange={v => setModel({ ...model, note: v })}
                    />
                </fieldset>
                <fieldset>
                    <FormActions disableInputs={disableInputs} />
                </fieldset>
            </Form>
        </div>
    );
};

export default WalletTransactionFrom;
